import { atomWithStorage } from "jotai/utils";

export enum SortOrderAtomEnum {
  NEW_ADS_FIRST = "desc",
  OLDEST_FIRST = "asc"
}

export const endedAuctionsSortOrderAtom = atomWithStorage<SortOrderAtomEnum>(
  "endedAuctionsSortOrderAtom",
  SortOrderAtomEnum.NEW_ADS_FIRST, // newest (the most recently published auctions) first
  undefined,
  { getOnInit: true }
);

export const activeAuctionsSortOrderAtom = atomWithStorage<SortOrderAtomEnum>(
  "activeAuctionsSortOrderAtom",
  SortOrderAtomEnum.OLDEST_FIRST, // oldest (the auctions closing soon) first
  undefined,
  { getOnInit: true }
);
